if (!customElements.get('appear-animate-single')) {
  class AppearAnimateSingle extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      if (!window.appearAnimate && this.dataset.force == undefined) return;
      Motion.inView(this, (info) => {
        this.showElement()
      });
    }

    showElement() {
      if(!this.dataset.immediate) {
        setTimeout(() => this.classList.add('appear'), 500);
      } else {
        this.classList.add('appear');
      }
    }
  };
  
  customElements.define('appear-animate-single', AppearAnimateSingle);
}

if (!customElements.get('appear-animate-list')) {
  class AppearAnimateList extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      if(!window.appearAnimate) return;
      this.delay = this.dataset.delay ? parseFloat(this.dataset.delay): 0.1;
      this.items = this.querySelectorAll('.appear-animate-item-in-list');
      Motion.inView(this, (info) => {
        this.classList.add('start');
        this.showElements();
      });
    }

    showElements() {
      Motion.animate(this.items, { transform: 'translateY(0)', opacity: 1 }, { delay: Motion.stagger(this.delay), duration: 0.5, easing: `cubic-bezier(.03,.93,.97,1)` }).finished.then(() => {
        this.items.forEach(item => {
          item.classList.add('done');
          setTimeout(() => item.removeAttribute('style'), 100);
        });
      });
    }

    reset() {
      if(!window.appearAnimate) return;
      this.items = this.querySelectorAll('.appear-animate-item-in-list:not(.done)');
      this.showElements();
    }
  };
  
  customElements.define('appear-animate-list', AppearAnimateList);
}

(function() {
  function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function formatDate(date) {
    return date.toLocaleDateString('en-ZA', { day: 'numeric', month: 'short' });
  }

  function injectBlackbeltDeliveryEstimate() {
    if (!document.body || document.querySelector('.bba-dynamic-delivery-estimate')) return;

    var priceBlock = document.querySelector('.bbmo__price-row') || document.querySelector('.bb-pdp__price-block');
    if (!priceBlock) return;

    var today = new Date();
    var startDate = addDays(today, 10);
    var endDate = addDays(today, 15);

    var estimate = document.createElement('div');
    estimate.className = 'bba-dynamic-delivery-estimate';
    estimate.setAttribute('role', 'note');
    estimate.innerHTML = '<span class="bba-dynamic-delivery-estimate__icon">🚚</span><span><strong>Get it between ' + formatDate(startDate) + ' and ' + formatDate(endDate) + '</strong><small>Order today to secure your unit</small></span>';

    estimate.style.cssText = 'display:flex;align-items:center;gap:10px;margin:2px 0 14px;padding:11px 13px;border:1px solid rgba(249,115,22,.32);border-radius:9px;background:rgba(249,115,22,.07);color:#fff;font-size:13px;line-height:1.25;';
    var icon = estimate.querySelector('.bba-dynamic-delivery-estimate__icon');
    if (icon) icon.style.cssText = 'font-size:18px;line-height:1;flex:0 0 auto;';
    var strong = estimate.querySelector('strong');
    if (strong) strong.style.cssText = 'display:block;color:#fff;font-weight:800;';
    var small = estimate.querySelector('small');
    if (small) small.style.cssText = 'display:block;margin-top:3px;color:#9ca3af;font-size:10px;font-weight:500;';

    priceBlock.insertAdjacentElement('afterend', estimate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectBlackbeltDeliveryEstimate);
  } else {
    injectBlackbeltDeliveryEstimate();
  }

  document.addEventListener('shopify:section:load', injectBlackbeltDeliveryEstimate);
})();